var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpAfiS4Icon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 17.114L15.7088 20.073C15.643 20.3101 15.5037 20.5202 15.3109 20.6732C15.1182 20.8261 14.882 20.9141 14.6361 20.9244C14.3903 20.9348 14.1475 20.8669 13.9426 20.7307C13.7377 20.5944 13.5813 20.3967 13.4958 20.166L10.7078 12.284C10.6315 12.0756 10.6162 11.8498 10.6639 11.6331C10.7117 11.4164 10.8203 11.2179 10.9771 11.0609C11.1339 10.9039 11.3323 10.795 11.5489 10.747C11.7655 10.699 11.9914 10.7139 12.1998 10.79L20.2358 13.578C20.4745 13.6604 20.6799 13.8181 20.8211 14.0275C20.9623 14.2369 21.0315 14.4865 21.0184 14.7386C21.0053 14.9908 20.9106 15.2319 20.7485 15.4255C20.5864 15.6191 20.3657 15.7547 20.1198 15.812L17.0078 16.322C16.8206 16.3774 16.6502 16.4789 16.5122 16.617C16.3742 16.7552 16.273 16.9257 16.2178 17.113",
    stroke: "#FFD600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 9.31399C21.0018 7.71863 20.0987 6.27917 18.8799 5.13457C17.6612 3.98996 16.168 3.17886 14.5444 2.77955C12.9208 2.38025 11.2218 2.40623 9.61115 2.85498C8.00054 3.30373 6.53282 4.1601 5.34964 5.34143C4.16647 6.52276 3.30782 7.98915 2.85655 9.59906C2.40529 11.209 2.37667 12.908 2.77344 14.5322C3.17022 16.1564 3.97899 17.6509 5.1217 18.8714C6.26441 20.0919 7.70245 20.9972 9.29703 21.5",
    stroke: "#FFD600",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpAfiS4Icon4);
export default __webpack_public_path__ + "static/media/lp_afi_s4_icon4.db8206a52205811be2f3eee3bf151e2a.svg";
export { ForwardRef as ReactComponent };